import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import { copyToClipboard } from '../../../utils/clipboard';
import { FormTemplate, buildTemplateConfig } from '../templateConfig';

interface TemplateCopyButtonProps {
  template: FormTemplate;
  disabled?: boolean;
  onCopied: (ok: boolean) => void;
}

const TemplateCopyButton: React.FC<TemplateCopyButtonProps> = ({ template, disabled, onCopied }) => (
  <Tooltip title="Copy template config">
    <span className="template-copy-anchor">
      <IconButton
        size="small"
        className="template-copy-button"
        aria-label={`Copy config of ${template.name}`}
        disabled={disabled}
        onClick={async (e) => {
          e.stopPropagation();
          onCopied(await copyToClipboard(buildTemplateConfig(template)));
        }}
      >
        <ContentCopyIcon fontSize="inherit" />
      </IconButton>
    </span>
  </Tooltip>
);

export default TemplateCopyButton;
